import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import { Navigate } from 'react-router-dom';


const ClientCompleteView = (props) => {
if (localStorage.getItem("token") != null) {
        return (
           <>
            <div className="registration-form_main">
                <div className="registration-form_wrapper" style={{padding: '78px 73px'}}>
            <div className="dashboard-body-area" style={{width: '100%'}}>
                <section className="dashboard-page-title" >
                      <h2 >Congrats you are now registered please go to the post a job feature to create your job</h2>
                      <br/>
                      <h2>The following details our now own file with our office.</h2>
                </section>
                 <section className="dashboard-page-title"  >
                      <h2 ><strong>Step 1: Company Details Complete </strong></h2>
                </section>
                <div style={{marginTop:'30px'}}>
                      <Table responsive>

                        <tbody >
                            <tr>
                                <td style={{minWidth: '15em'}}>Company Number</td>
                                <td><span className="title-crop">{props.company_detail.company_number}</span></td>

                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Legal Entity</td>
                                <td><span className="title-crop">{props.company_detail.entity}</span></td>

                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Registered office</td>
                                <td><span className="title-crop">{props.company_detail.office_address}</span></td>

                            </tr>


                            <tr>
                                <td style={{minWidth: '15em'}}>Trading Address</td>
                                <td><span className="title-crop">{props.company_detail.trading_address}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Communication Address</td>
                                <td><span className="title-crop">{props.company_detail.communication_address}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Phone Number</td>
                                <td><span className="title-crop">{props.company_detail.phone_number}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Fax</td>
                                <td><span className="title-crop">{props.company_detail.Fax_number}</span></td>
                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Email</td>
                                <td><span className="title-crop">{props.company_detail.email}</span></td>
                            </tr>



                        </tbody>
                    </Table>
                </div>
                <section className="dashboard-page-title" style={{marginTop:'10px'}} >
                      <h2 >You Can Start posting the Job. Click Here To Post the Job</h2>
                      <div  style={{padding: '11px 0',width: '350px',margin:'0px 0px'}}>
                      <form>
                      <div className="form-btn_group" style={{textAlign:'start'}}>
                      <a href="/job-post" ><button type="button" style={{width: '285px'}} className="btn btn-border">Post Job <i className="fa fa-pencil-square-o"></i></button></a>
                      </div>
                       </form>
                        </div>
                </section>

            </div>
             </div>
              </div>
        </>
        )
}else{
            return(
                <Navigate to="/login" />
             )
}
}

export default ClientCompleteView;